import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { Button } from '@scramble/ui';
import IconSuccess from './phone-01.svg';
import s from '../index.module.scss';

export const SuccessMessage = ({ onClose }) => {
  const { t } = useTranslation();

  return (
    <div className={classnames(s.modal, s.success_modal)}>
      <div className={s.content}>
        <div className={s.success}>
          <div className={s.success_icon}>
            <img src={IconSuccess} alt="icon" width={28} height={28} />
          </div>
          <div className={s.success_title}>
            {t('modal:phone_verify_modal.success_title')}
          </div>
          <div className={s.success_desc}>
            {t('modal:phone_verify_modal.success_message')}
          </div>
        </div>
      </div>
      <div className={s.footer}>
        <Button
          theme="neutral"
          appearance="filled"
          size="lg"
          onClick={onClose}
          className={s.btn_close}
          label={t('modal:phone_verify_modal.got_it')}
        />
      </div>
    </div>
  );
};
